enum StorageLocation {
  Local = 'local',
  Session = 'session'
}

const getStorage = (location: StorageLocation) => {
  switch (location) {
    case StorageLocation.Session:
      return window.sessionStorage;
    case StorageLocation.Local:
    default:
      return window.localStorage;
  }
};

const saveState = (key: string, state: any, location = StorageLocation.Session) => {
  const storage = getStorage(location);
  storage.setItem(key, JSON.stringify(state));
};

const getState = (key: string, location = StorageLocation.Session) => {
  const storage = getStorage(location);
  const item = storage.getItem(key);
  if (item) {
    return JSON.parse(item);
  }
};

const deleteState = (key: string, location = StorageLocation.Session) => {
  const storage = getStorage(location);
  storage.removeItem(key);
};

const getDayLabel = (timestamp: Date) => {
  const date = new Date(timestamp);
  const options = {
    weekday: 'long',
    year: 'numeric',
    month: 'long',
    day: 'numeric'
  };
  const dateTimeFormat = new Intl.DateTimeFormat('en-GB', options);
  return dateTimeFormat.format(date);
};

const formatMinutes = (minutes: number) => {
  const hours = Math.max(minutes / 60, 0);
  const dispHours = Math.floor(hours);
  const min = (hours - dispHours) * 60;
  const dispMin = Math.floor(min);

  return `${dispHours}h ${dispMin}m`;
};

const prettifyString = (string: string) => {
  if (!!string) {
    return string.toLowerCase().replace(/_/g, ' ');
  }
  return '';
}

export { getState, saveState, deleteState, getDayLabel, formatMinutes, prettifyString };
